// Core
import styled from 'styled-components';

// Libraries
import { List as AntdList } from 'antd';

// Component
import { EquipmentSensorListItem } from './EquipmentSensorList.types';

export const Container = styled(AntdList<EquipmentSensorListItem>)<{ hasLargePadding?: boolean }>`

  .ant-list-header {
    border: 1px solid ${({ theme }) => (theme.color.equipmentSensorList.borderColor)};
    border-radius: 4px 4px 0 0;
    border-bottom: none;
    color: ${({ theme }) => (theme.color.equipmentSensorList.headerTextColor)};
    font-size: 12px;
    font-family: ${({ theme }) => theme.font.regular};
  };

  .ant-list-item:first-child {
    border-top: 1px solid ${({ theme }) => (theme.color.equipmentSensorList.borderColor)};
  };

  .ant-list-item:last-child {
    border-bottom: 1px solid ${({ theme }) => (theme.color.equipmentSensorList.borderColor)};
    border-radius: 0 0 4px 4px !important;
  };

  .ant-list-item {
    padding-left: 16px;
    padding-right: 10px;
  };
`;

/* ************** HEADER ******************* */

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 10px;
`;

export const TitleLeftContainer = styled.div`
  width: 100%;
`;

export const TitleRightContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const TitleRightContent = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  
  :first-child,
  :last-child {
    align-items: center;
    justify-content: center;
    width: 130px;
  };
`;

/* ************** ITEMS ******************* */

export const ListContainer = styled(AntdList.Item)`
  border: 1px solid ${({ theme }) => (theme.color.equipmentSensorList.borderColor)};
  border-top: none;
  display: flex;
  height: 100%;
`;

export const ItemsLeftContainer = styled.div<{ isBold?: boolean; hasLargePadding?: boolean }>`
  color: ${({ theme, isBold }) => (
    isBold
      ? theme.color.equipmentSensorList.leftItemsBoldTextColor
      : theme.color.equipmentSensorList.leftItemsTextColor
  )};
  font-family: ${({ theme, isBold }) => (isBold ? theme.font.bold : theme.font.medium)};
  font-size: 14px;
  width: 100%;
  padding-left: ${({ hasLargePadding }) => (hasLargePadding ? '16px' : '0px')} !important;
`;

export const ItemsRightContainer = styled.div`
  color: ${({ theme }) => (theme.color.equipmentSensorList.rightItemsTextColor)};
  display: flex;
  font-family: ${({ theme }) => theme.font.bold};
  font-size: 12px;
  justify-content: flex-end;
`;

export const ItemsRightContent = styled.div`
  display: flex;
  justify-content: center;

  :first-child,
  :last-child {
    align-items: center;
    justify-content: center;
    width: 130px;
  };
`;

export const TooltipContent = styled.span`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
